import { createContext, useContext, useEffect } from 'react';

import type { RailCountKey } from './nav-model';

/**
 * De tellers rechts in de rail: stops vandaag, open keuringen, rapporten die
 * wachten.
 *
 * De schil haalt die getallen bewust niet zelf op. Hij weet niets van keuringen
 * en zou anders bij elke navigatie dezelfde lijsten opnieuw bevragen als het
 * scherm eronder. In plaats daarvan publiceert het scherm dat de gegevens tóch
 * al heeft zijn getal:
 *
 *     useRailCount('reports', rapporten.data?.wachtend.length);
 *
 * Een `undefined` telt als "onbekend": het item toont dan geen badge. Bij het
 * verlaten van het scherm ruimt de hook zijn eigen getal op.
 */
export type RailCounts = Partial<Record<RailCountKey, number>>;

export type PublishRailCount = (key: RailCountKey, value: number | undefined) => void;

export const RailCountsContext = createContext<RailCounts>({});

export const PublishRailCountContext = createContext<PublishRailCount>(() => {});

/** Leest de tellers. Alleen de rail heeft dit nodig. */
export function useRailCounts(): RailCounts {
    return useContext(RailCountsContext);
}

/** Publiceert één teller zolang dit scherm in beeld is. */
export function useRailCount(key: RailCountKey, value: number | undefined): void {
    const publish = useContext(PublishRailCountContext);

    useEffect(() => {
        publish(key, value);

        return () => publish(key, undefined);
    }, [publish, key, value]);
}
